import { gql, useMutation } from '@apollo/client';
import { GET_USER } from './useUserQuery';
import { GET_DPO_INFO } from '@dieterApi/dpo/useDpoInfoQuery';

const USER_UPDATE_DPO = gql`
  mutation UpdateUserDpo(
    $userId: ID!
    $dpoName: String
    $dpoEmail: String
    $dpoPhone: String
    $dpoAddress: String
    $dpoCompany: String
  ) {
    updateUserDpo(
      userId: $userId
      dpoName: $dpoName
      dpoEmail: $dpoEmail
      dpoPhone: $dpoPhone
      dpoAddress: $dpoAddress
      dpoCompany: $dpoCompany
    ) {
      id
      dpoName
      dpoEmail
      dpoPhone
      dpoAddress
      dpoCompany
    }
  }
`;

export function useUserUpdateDpoMutation() {
  return useMutation(USER_UPDATE_DPO, {
    refetchQueries: [
      { query: GET_USER },
      'GetDpoInfo', // Refetch all GetDpoInfo queries regardless of variables
    ],
  });
}
